export default function injectParamsInRoute(route, params) {
  Object.entries(params).forEach(function ([id, value]) {
    route = route.replace(':' + id, value);
  });

  return route;
}
